import React, { Component } from 'react';
import { Dropdown, DropdownMenu } from 'reactstrap';
import { Link } from 'react-router-dom'
import { userRef, onSaleRef } from '../../config'
import UserImg from '../../assets/img/user.png';
import Notifications, {notify} from 'react-notify-toast';

class Header extends Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.logout = this.logout.bind(this)
    this.toggleNotification = this.toggleNotification.bind(this)
    this.approveUser = this.approveUser.bind(this)
    this.disproveUser = this.disproveUser.bind(this)
    this.state = {
      dropdownOpen: false,
      notificationOpen: false,
      usersPendingApproval: [],
      notification:true,
      verificationLink:false
    };
  }

  componentDidMount() {
    onSaleRef.orderByChild('assignedTo').equalTo(localStorage.getItem('uid')).once('value', snap => {
      if (snap.exists()) {
        this.setState({
          notifications: Object.keys(snap.val()).map(k => snap.val()[k])
        })
      }
    })
    userRef.orderByChild('pendingApproval').equalTo(true).once('value', s => {
      if (s.exists()) {
        this.setState({
          usersPendingApproval: Object.keys(s.val()).map(k => s.val()[k])
        })
      }
    })
    this.verificationNotify()
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  toggleNotification() {
    this.setState({
      notificationOpen: !this.state.notificationOpen
    })
  }

  logout(e) {
    Object.keys(localStorage).map(k => {
      localStorage[k] = null
    })
    localStorage.setItem('loggedIn', false)
  }

  approveUser(user) {
    userRef.child(user.uid).child('pendingApproval').set(false)
    userRef.child(user.uid).child('accountStatus').set('enabled')
    this.setState({
      usersPendingApproval: this.state.usersPendingApproval.filter(u => u.uid !== user.uid)
    })
  }
  disproveUser(user) {
    userRef.child(user.uid).child('pendingApproval').set(false)
    userRef.child(user.uid).child('accountStatus').set('disabled')
    this.setState({
      usersPendingApproval: this.state.usersPendingApproval.filter(u => u.uid !== user.uid)
    })
  }

  verificationNotify = () => {
    if(localStorage.userType === "admin"){
      userRef.once("value", snapshot => {
        snapshot.forEach(snap => {
          if(typeof snap.val().LinkedUsers != "undefined"){
            userRef.child(snap.key).child("LinkedUsers").orderByChild("status").equalTo("pending")
            .once("value", s => {
              if(s.exists()){
                if(this.state.notification === true){
                  let color = { background: '#5bc0de', text: "#FFFFFF" };
                  notify.show("Code verification requested", "custom", 5000, color);
                  this.setState({
                    notification:false
                  })
                }
              }
            })
          }
          // if(typeof snap.val().LinkedUsers){
          //   console.log(snap.key)
          // }
        })
      })
    }
  } 

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('slide-close');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  render() {
    let userType = localStorage.getItem('userType')
    return (
      <header className="fixed-top">
        <Notifications />
        <div className="container-fluid">
          <div className="row flex-row align-center">
            <div className="col-lg-7 col-2 col-md-5">
              <button onClick={this.sidebarToggle} className="btn btn-red btn-danger circle-side">
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            </div>
            <div className="col-lg-5 col-10 col-md-7">
              <div className="user-info">

                <Dropdown className="pull-left" isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                  {/* <button style={{'margin-right': '27px'}}  className="nav-link dropdown-toggle" data-toggle="dropdown" type="button" aria-haspopup="true" aria-expanded={this.state.dropdownOpen}>
                            <span className="d-md-down-none">{`${localStorage.getItem('firstName')}  ${localStorage.getItem('lastName')}`}</span>
                          </button> */}
                  <div className="dropdown-toggle" aria-haspopup="true" aria-expanded={this.state.dropdownOpen}>
                    <span className="user-img" onClick={this.toggleNotification}>
                      {userType === 'admin' ?
                        <Dropdown isOpen={this.state.notificationOpen} toggle={this.toggleNotification}>
                          <i className='icon-bell'></i>
                          {this.state.usersPendingApproval.length > 0 ? <span className='badge badge-pill badge-danger'> {this.state.usersPendingApproval.length} </span> : null}
                          <DropdownMenu className='dropdown-menu-right user-notis'>
                            <div className='dropdown-header text-xs-center '>
                              <strong> {this.state.usersPendingApproval.length > 0 ? 'Accounts Pending Approval' : 'No notifications'}</strong>
                            </div>
                            <div className='card'>
                              <div className='card-block'>
                                {this.state.usersPendingApproval.length > 0 ? <table className='table table-sm'>
                                  <thead>
                                    <tr>
                                      <th> User </th>
                                      <th> Approve </th>
                                      <th> Disprove </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.usersPendingApproval.map((user,index) => {
                                      return (
                                        <tr key={index}>
                                          <td> {`${user.firstName} ${user.lastName}`} </td>
                                          <td> <button onClick={() => this.approveUser(user)} className='btn btn-success btn-xs'> <i className="fa fa-check"></i> </button> </td>
                                          <td> <button onClick={() => this.disproveUser(user)} className='btn btn-danger btn-xs'> <i className="fa fa-remove"></i> </button> </td>
                                        </tr>
                                      )
                                    })}
                                  </tbody>
                                </table> : ''}
                              </div>
                            </div>
                          </DropdownMenu>
                        </Dropdown> : <img src={UserImg} alt="user" className="img-circle" />
                      }
                    </span>
                    <span onClick={this.toggle}>{`${localStorage.getItem('firstName')}  ${localStorage.getItem('lastName')}`}
                      <i className="ion-chevron-down icon"></i></span>
                  </div>
                  <DropdownMenu>
                    {userType === 'admin' ? <li> <Link to='/admin'> <i className='fa fa-user' /> Admin Panel </Link> </li> : null}
                    <li> <Link to='/login' onClick={this.logout}><i className="fa fa-lock"></i> Logout</Link></li>
                  </DropdownMenu>
                </Dropdown>
                {/* <div className="dropdown-toggle" type="button" data-toggle="dropdown">
                                <span className="user-img"><img src="../img/user.png" alt="user" className="img-circle" /></span>JOHN MICHALE
                                <button className="ion-chevron-down icon" onClick={this.toggle} data-toggle="dropdown"></button>
                            </div>
                            <ul className="dropdown-menu">
                                <li><a href="#">Profile</a></li>
                                <li><a href="#">Setting</a></li>
                                <li><a href="#">Help</a></li>
                            </ul> */}
              </div>
            </div>
          </div>
        </div>
      </header>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js